import { BaseService } from "./baseService";
class JobInvoiceService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "job_invoice";
    }
}
export const jobInvoiceService = new JobInvoiceService();
//# sourceMappingURL=jobInvoiceService.js.map